// extracted by mini-css-extract-plugin
export var root = "q_qD";
export var wrapper = "q_p7";
export var image = "q_qF d_s d_v d_S";
export var crop = "q_qG";
export var round = "q_qH";
export var fixedHeight = "q_qJ";